import React from 'react';
import { Card, Dimmer, Loader } from 'semantic-ui-react';
import { withApollo, compose } from 'react-apollo';
import _ from 'lodash';

import Content from '../Content';
import ClaimHistory from './ClaimHistory';
import ClaimDetails from './ClaimDetails';
import mapConnection from '../../utils/connectionMapper';
import PathView from '../PathView';
import { withPagination } from '../../utils/pagination';
import PaginationWrapper from '../PaginationWrapper';
import DocumentTitle from '../DocumentTitle';

import withClaimQuery from '../HOC/withClaimQuery';

const ITEMS_PER_PAGE = 30;
class ClaimContainer extends React.Component {
  state = {};

  handleClaimUpdated = () => this.props.refetch();
  hideLoading = () => this.setState({ loading: false });
  showLoading = () => this.setState({ loading: true });

  render = () => {
    const { claim, variables, loading, match } = this.props;
    const historyEntries = _.get(claim, 'claimHistoryEntriesConnection');
    const pageInfo = historyEntries ? historyEntries.pageInfo : {};
    const history = historyEntries ? mapConnection(historyEntries) : [];
    return (
      <Content fullWidth>
        <Dimmer active={loading || this.state.loading} inverted page>
          <Loader inverted />
        </Dimmer>
        <DocumentTitle title={`Claim ${match.params.id}`} />
        <PathView
          paths={[
            { name: 'Claims', path: '/claims' },
            { name: variables.id || {} }
          ]}
        />
        <Card fluid>
          {claim && (
            <ClaimDetails
              key={claim.id}
              claim={claim}
              onClaimUpdated={this.handleClaimUpdated}
              hideLoading={this.hideLoading}
              showLoading={this.showLoading}
            />
          )}
        </Card>
        <ClaimHistory history={history} />
        <PaginationWrapper {...pageInfo} perPage={ITEMS_PER_PAGE} />
      </Content>
    );
  };
}

export default compose(
  withPagination(),
  withApollo,
  withClaimQuery
)(ClaimContainer);



// WEBPACK FOOTER //
// ./src/component/ClaimPage/index.js